<template>
  <div class="button-groups__container">
    <div class="mds-button-group">
      <label
        class="mds-button__input-outer-wrapper"
        :for="button.name"
        :key="index"
        v-for="(button, index) in buttons"
      >
        <input
          class="mds-button__input"
          type="radio"
          name="type"
          :id="button.name"
          :value="button.value"
          :checked="button.value == active"
          @click="onSelect(button.value)"
        />
        <span class="mds-button mds-button--secondary" :for="button.name">
          {{ button.label }}
        </span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'button-groups',
  props: {
    buttons: {
      type: Array,
      default() {
        return [
          {
            label: 'Default',
            name: 'default',
            value: 'default',
          },
        ];
      },
    },
    active: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    onSelect(selected) {
      this.$emit('onSelected', selected);
    },
  },
};
</script>
<style lang="scss">
.button-groups {
  &__container {
    text-align: center;
    padding: $mds-space-3-x 0;
  }
}
</style>
